export default __webpack_public_path__ + "static/media/image-export-excel.901a5f84.png";